import { combineReducers } from 'redux';
import { default as list } from 'accounts/reducers/accounts_list_reducers';
import { default as form } from 'accounts/reducers/accounts_form_reducers';

export const accountsReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/reducers/index.js